export default "__VITE_ASSET__BlO94MHm__"